module.exports = __webpack_public_path__ + "img/pin-driver.a0792f23.svg";